<template>
  <div class="cta">
    <vb-button
      class="cta__btn"
      :vb_options="{
        text: 'Continua',
        variant: 'info',
        icon_disabled: 'lock_v2',
        disabled: cta_status.disabled || !get_availability(property_data.live_price).can_go_to_checkout
      }"
      @click="scroll_to_bottom()"
    />
    <div v-if="cta_status.disabled" :class="'cta__text text-' + cta_status.variant" >
      <vb-icon class="cta__text-icon mr-1" :name="'info'" :color="sass(cta_status.variant)" :size="14" />
      <p class="mb-0" v-html="cta_status.label" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'resume-cta',

  inject: ['cta_status_checker'],

  components: {
  },

  props: {
    property_data: Object
  },

  data() {
    return {
    }
  },

  computed: {

    // Gestisce i copy e lo stato della cta
    cta_status(){

      let label = `Scegli una camera <span class="d-block mt-1 ml-n3 text--sm">Seleziona l'opzione più adatta alle tue esigenze.</span>`,
          variant = 'dark'

      const result = {  // ci torna utile per implementazione multicamera
        disabled: Object.keys(this.property_data).length === 0,
        label,
        variant
      }
      this.cta_status_checker(result)
      return result
    }

  },

  created() {
  },

  mounted() {
  },

  methods: {

    scroll_to_bottom() {
      window.scroll({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      })
    }

  },
}
</script>

<style lang="scss" scoped>

  .cta {
    display: flex;
    align-items: center;
    flex-direction: column;

    @include media-breakpoint-up(xl){
      display: block
    }

    &__btn {
      line-height: normal;
    }

    &__text {
      margin-bottom: 0;
      margin-top: $grid-gutter-width;
      line-height: 18px;
      text-align: center;

      @include media-breakpoint-up(xl){
        display: flex;
        align-items: flex-start;
        text-align: left;
      }

      &-icon {
        display: none;

        @include media-breakpoint-up(xl){
          margin-top: 2px;
          display: block;
        }
      }
    }
  }

</style>